import posthog from 'posthog-js'

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST

export function initPostHog() {
  if (typeof window === 'undefined') {
    return
  }

  if (!POSTHOG_KEY || !POSTHOG_HOST) {
    console.warn('PostHog not configured')
    return
  }

  if (!posthog || typeof posthog.init !== 'function') {
    console.warn('PostHog client is unavailable in this environment')
    return
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    loaded: (posthog) => {
      if (import.meta.env.DEV) {
        posthog.debug()
      }
    }
  })
}

export function captureEvent(eventName: string, properties?: Record<string, any>) {
  if (posthog) {
    posthog.capture(eventName, properties)
  }
}

export function identifyUser(userId: string, properties?: Record<string, any>) {
  if (posthog) {
    posthog.identify(userId, properties)
  }
}

export default posthog
